export const STOP_SIZE = 20;
export const TOTAL = 100;
export const STOPS = ["Base Camp", "Forest Trail", "River Crossing", "Ridge Point", "Summit"];

export const FUN_FACTS = [
  "ISRO reached Mars orbit on its very first attempt with the Mangalyaan mission in 2014. Thousands of engineers and scientists worked on it.",
  "With Chandrayaan-3 in 2023, India became the first country to land a spacecraft near the Moon's south pole.",
  "Architects in India must be registered with the Council of Architecture before they can practise as architects.",
  "To fly passenger planes in India, pilots need a Commercial Pilot Licence issued by the DGCA.",
  "Forensic scientists help solve crimes by studying tiny clues like fingerprints, fibres and DNA.",
  "Officers of the Army, Navy and Air Force train together at the National Defence Academy near Pune.",
  "Food technologists design how packaged foods stay fresh, safe and tasty, from biscuits to juices.",
  "Wildlife biologists in India count tigers using camera traps hidden deep inside forests.",
  "Sign language interpreters help Deaf people take part in classrooms, courts and TV news.",
  "Game designers plan the rules, levels and stories of a video game before a single line of code is written.",
  "Marine biologists study life along India's long coastline, from coral reefs to mangrove forests.",
  "Foley artists create the sounds you hear in films, like footsteps or rain, often recording them separately in a studio.",
  "Urban planners decide where roads, parks, schools and metro lines should go in a growing city.",
  "Actuaries use maths and statistics to help insurance companies plan for the future.",
  "Chartered Accountants in India qualify through ICAI exams at three levels: Foundation, Intermediate and Final.",
  "You can start a law career straight after Class 12 through five-year integrated programmes like BA LLB.",
  "Ethical hackers are paid to find weaknesses in computer systems before criminals do.",
  "Agricultural scientists develop seeds that grow with less water, helping farmers through dry years.",
  "Physiotherapists help athletes, older people and patients recovering from surgery move better.",
  "Hand-drawn animation can need 12 to 24 separate drawings for just one second on screen.",
  "Data scientists find patterns in huge amounts of information, like which songs people replay the most.",
  "Interior designers plan how a space feels by choosing light, colour, furniture and materials.",
  "Museum curators research, protect and display objects that tell the story of our past.",
  "Meteorologists at the India Meteorological Department forecast the monsoon that millions of farmers depend on.",
  "Speech therapists help children and adults who find it hard to speak, listen or swallow.",
  "Robotics engineers combine mechanical, electrical and computer engineering in a single job.",
  "Good journalists check a fact with more than one source before a story is published.",
  "Hotel management graduates work in hotels, airlines, cruise ships, hospitals and event companies.",
  "Civil engineers built the Chenab Rail Bridge in Jammu and Kashmir, the world's highest railway arch bridge.",
  "Fashion designers often begin with a mood board of colours, textures and pictures before they sketch.",
  "Counsellors and psychologists help people understand their feelings and cope with stress.",
  "Environmental engineers design ways to clean water, reduce air pollution and manage waste.",
  "Many great careers began with one inspiring teacher, and good teachers are needed everywhere.",
  "Pharmacists double-check medicines so that every patient gets the right medicine at the right dose.",
  "UX designers watch how people use apps and websites, then make them simpler to use.",
  "Economists study how people, businesses and governments make choices about money and resources.",
  "In professional kitchens, each chef usually runs one station, such as sauces, grills or desserts.",
  "Archaeologists have uncovered Harappan cities in India with planned streets and covered drains, over 4,000 years old.",
  "Careers like social media manager and drone pilot barely existed 25 years ago. New ones keep appearing.",
  "Indian Foreign Service officers represent India in embassies around the world and are selected through the UPSC Civil Services exam.",
  "Biomedical engineers design devices like artificial limbs, pacemakers and hospital scanners.",
  "Wildlife photographers may wait for hours, or even days, to capture one perfect picture.",
];

export function factsFor(seed) {
  let h = 0;
  for (const c of seed) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  const list = [...FUN_FACTS];
  for (let i = list.length - 1; i > 0; i--) {
    h = (h * 1103515245 + 12345) >>> 0;
    const j = h % (i + 1);
    [list[i], list[j]] = [list[j], list[i]];
  }
  return list;
}
